import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border-0 px-2.5 py-1 text-xs font-bold transition-colors duration-150 focus:outline-none",
  {
    variants: {
      variant: {
        default: "bg-[#1f4171] text-white",
        secondary: "bg-[#f5f7fa] text-[#1f4171]",
        mint: "bg-[#e8fcf9] text-[#0f766e]",
        coral: "bg-[#ffeee7] text-[#ff7d3c]",
        muted: "bg-[#f5f7fa] text-slate-600 font-medium",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }

